import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Navigation3D from "./Navigation3D";

export const Header = (props) => {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const [show3DNav, setShow3DNav] = useState(false);
  const videos = [
    "/video/computer.mp4",
    "/video/space_agri2.mp4", 
    "/video/space_agri.mp4",
    "/video/mobility.mp4",
    // 必要に応じて動画を追加
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentVideoIndex((prevIndex) => 
        prevIndex === videos.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000); // 5秒ごとに切り替え

    return () => clearInterval(interval);
  }, []);

  return (
    <header id="header">
      <div className="intro">
        <div className="video-background">
          {videos.map((video, index) => (
            <video
              key={index}
              className={`background-video ${index === currentVideoIndex ? 'active' : ''}`}
              autoPlay
              muted
              loop
              playsInline
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                opacity: index === currentVideoIndex ? 1 : 0,
                transition: 'opacity 1s ease-in-out'
              }}
            >
              <source src={video} type="video/mp4" />
            </video>
          ))}
        </div>
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text">
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : "Loading"}</p>
                
                {/* CTAボタンセクション */}
                <div style={{ marginTop: '40px', display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
                  <a
                    href="#features"
                    className="btn btn-custom btn-lg page-scroll"
                  >
                    サービス詳細
                  </a>
                  
                  <Link
                    to="/technology"
                    className="btn btn-custom btn-lg"
                    style={{ 
                      background: 'rgba(255, 255, 255, 0.2)',
                      border: '2px solid rgba(255, 255, 255, 0.8)',
                      color: 'white'
                    }}
                  >
                    技術詳細
                  </Link>
                  
                  <Link
                    to="/solutions"
                    className="btn btn-custom btn-lg"
                    style={{ 
                      background: 'rgba(59, 130, 246, 0.8)',
                      border: '2px solid #3b82f6',
                      color: 'white'
                    }}
                  >
                    ソリューション
                  </Link>
                  
                  <Link
                    to="/case-studies"
                    className="btn btn-custom btn-lg"
                    style={{ 
                      background: 'rgba(16, 185, 129, 0.8)',
                      border: '2px solid #10b981',
                      color: 'white'
                    }}
                  >
                    導入事例
                  </Link>
                </div>

                {/* セカンダリナビゲーション */}
                <div style={{ marginTop: '30px', display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
                  <Link
                    to="/company"
                    style={{ 
                      color: 'rgba(255, 255, 255, 0.8)',
                      textDecoration: 'none',
                      fontSize: '16px',
                      fontWeight: '500',
                      borderBottom: '1px solid transparent',
                      transition: 'all 0.3s'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.color = 'white';
                      e.target.style.borderBottomColor = 'white';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                      e.target.style.borderBottomColor = 'transparent';
                    }}
                  >
                    企業情報
                  </Link>
                  
                  <Link
                    to="/resources"
                    style={{ 
                      color: 'rgba(255, 255, 255, 0.8)',
                      textDecoration: 'none',
                      fontSize: '16px',
                      fontWeight: '500',
                      borderBottom: '1px solid transparent',
                      transition: 'all 0.3s'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.color = 'white';
                      e.target.style.borderBottomColor = 'white';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                      e.target.style.borderBottomColor = 'transparent';
                    }}
                  >
                    リソース
                  </Link>
                  
                  <Link
                    to="/news"
                    style={{ 
                      color: 'rgba(255, 255, 255, 0.8)',
                      textDecoration: 'none',
                      fontSize: '16px',
                      fontWeight: '500',
                      borderBottom: '1px solid transparent',
                      transition: 'all 0.3s'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.color = 'white';
                      e.target.style.borderBottomColor = 'white';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                      e.target.style.borderBottomColor = 'transparent';
                    }}
                  >
                    ニュース
                  </Link>
                  
                  <Link
                    to="/careers"
                    style={{ 
                      color: 'rgba(255, 255, 255, 0.8)',
                      textDecoration: 'none',
                      fontSize: '16px',
                      fontWeight: '500',
                      borderBottom: '1px solid transparent',
                      transition: 'all 0.3s'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.color = 'white';
                      e.target.style.borderBottomColor = 'white';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                      e.target.style.borderBottomColor = 'transparent';
                    }}
                  >
                    採用情報
                  </Link>
                  
                  <Link
                    to="/contact"
                    style={{ 
                      color: 'rgba(255, 255, 255, 0.8)',
                      textDecoration: 'none',
                      fontSize: '16px',
                      fontWeight: '500',
                      borderBottom: '1px solid transparent',
                      transition: 'all 0.3s'
                    }}
                    onMouseOver={(e) => {
                      e.target.style.color = 'white';
                      e.target.style.borderBottomColor = 'white';
                    }}
                    onMouseOut={(e) => {
                      e.target.style.color = 'rgba(255, 255, 255, 0.8)';
                      e.target.style.borderBottomColor = 'transparent';
                    }}
                  >
                    お問い合わせ
                  </Link>
                </div>

                {/* 3Dナビゲーションボタン */}
                <div style={{ marginTop: '30px', textAlign: 'center' }}>
                  <button
                    onClick={() => setShow3DNav(true)}
                    className="btn btn-custom btn-lg"
                    style={{ 
                      background: 'rgba(255, 255, 255, 0.1)',
                      border: '2px solid rgba(255, 255, 255, 0.5)',
                      color: 'white',
                      fontSize: '16px',
                      padding: '12px 24px'
                    }}
                  >
                    ３Dナビゲーション
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 3Dナビゲーションモーダル */}
      {show3DNav && (
        <Navigation3D onClose={() => setShow3DNav(false)} />
      )}
    </header>
  );
};
